import { Boxes, Cloud, LifeBuoy, Users } from 'lucide-react';

/**
 * The integrations the entity catalogue spans (CT-5191 / CT-5192).
 *
 * The `id`s are exactly what `listEntities({ integration })` accepts — the
 * source pills put this value in the request payload, so a mismatch here
 * silently returns an empty list rather than an error.
 */
export const INTEGRATIONS = Object.freeze([
  Object.freeze({ id: 'salesforce', labelKey: 'widgetBuilder.data.integrations.salesforce', icon: Cloud }),
  Object.freeze({ id: 'zendesk', labelKey: 'widgetBuilder.data.integrations.zendesk', icon: LifeBuoy }),
  Object.freeze({ id: 'bamboohr', labelKey: 'widgetBuilder.data.integrations.bamboohr', icon: Users }),
  Object.freeze({ id: 'aims_os', labelKey: 'widgetBuilder.data.integrations.aimsOs', icon: Boxes }),
]);

/** Label key for an integration id, or `null` when it is not one we know. */
export const integrationLabelKey = (id) =>
  INTEGRATIONS.find((integration) => integration.id === id)?.labelKey ?? null;

export default INTEGRATIONS;
